import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

interface IText {
  title: string;
  body: {
    lineOne: string;
    lineTwo: string;
  };
}

export const TextBody = () => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.CompassRights
  ).agreementModal;

  const isDesktop = useIsDesktop();

  const text: string[] = [
    dictionary.paragraph1,
    dictionary.paragraph2,
    dictionary.paragraph3,
  ];

  return (
    <Stack gap={isDesktop ? '12px' : '24px'} alignItems={'center'}>
      <Typography variant={'h2'}>{dictionary.title}</Typography>
      <Stack gap={'24px'}>
        {text.map((label: string, index: number) => (
          <Stack key={index}>
            <Typography variant={'body6'}>{label}</Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
